import logoSrc from "@/assets/logo.webp";
import clsx from "clsx";
import type { FunctionalComponent } from "preact";

interface Props {
    class?: string;
    word1: string;
    word2: string;
}

const Logo: FunctionalComponent<Props> = (props) => {
    return (
        <div class={clsx("flex flex-col items-center justify-center font-[RetroGaming]", props.class)}>
            <img class="-mb-2 w-24" src={logoSrc} alt="logo for this application" />
            <h1 class="text-center font-semibold text-white text-xl">
                <span class="text-[#00c3e3]">{props.word1}</span>
                <span class="text-[#ff4554]">{props.word2}</span>
            </h1>
        </div>
    );
};

export default Logo;
